import axios from "axios";
import LocalStorageService from "./localStorage";
import { ErrorLog } from "./ErrorLog";
//import { ACCESS_TOKEN_EXPIRED_VALIDATION_ERRORS } from "../Constants/ValidationErrorsi18";

//This is the hqi local url, we will change it later.
let defautlURL = "";
let defaultUmApi = process.env.REACT_API_URL;
let defaultSemanticApi = process.env.REACT_APP_HQI_SEMANTIC_URL;
let defaultMiddlewareApi = process.env.REACT_APP_HQI_MIDDLEWARE_URL;



export const hqiApiInstance = axios.create({
  baseURL: defautlURL,
  //Commenting for now, will figure out in future how to use the api's for micro frontend.
  // localStorage.hqiUrl,
});

hqiApiInstance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hqiApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (apiError) {
    try {
      const originalRequest = apiError.config;
      //Try to optimize this @Shweta
      const apiInstance = axios.create({
        baseURL: localStorage.refreshTokenUrl,
      });
      
      if (apiError.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = LocalStorageService.getRefreshToken();
        let url = window.location.hostname == 'localhost' ? 'https://hqi-dev.axtria.com' : window.location.origin;
        return axios
          .post(url+'/umbackend'+'/refresh', {
            refresh_token: refreshToken,
          })
          .then((res) => {
            if (res.status === 200) {
              LocalStorageService.setToken(res.data.data);
              hqiApiInstance.defaults.headers.common['Authorization'] =
                'Bearer ' + LocalStorageService.getAccessToken();
              return hqiApiInstance(originalRequest);
            } else if (res.status === 203) {
              localStorage.clear();
            }
          });
      // TODO's need to handle the 400 and above the status code in catch block
      } else if (apiError.response.status === 400) {
        return apiError.response;
      } else if (apiError.response.status === 409) {
        return apiError.response;
      }
      return Promise.reject(apiError);
    } catch (error) {
      //Call error message component and pass msg.
      ErrorLog("API Instance", error);
    }
  }
);


export const hqiUmApiInstance = axios.create({
  baseURL: defaultUmApi,
  //Commenting for now, will figure out in future how to use the api's for micro frontend.
  // localStorage.hqiUrl,
});

export const hqiSemanticApiInstance = axios.create({
  baseURL: defaultSemanticApi,
});

hqiSemanticApiInstance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hqiSemanticApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (apiError) {
    try {
      const originalRequest = apiError.config;
      const apiInstance = axios.create({
        baseURL: localStorage.refreshTokenUrl,
      });
      
      
      if (apiError.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = LocalStorageService.getRefreshToken();
        let url = window.location.hostname == 'localhost' ? 'https://hqi-dev.axtria.com' : window.location.hostname == 'hqi-dev1.axtria.com' ? 'https://hqi-dev.axtria.com' : window.location.origin;
        return axios
          .post(url+'/umbackend'+'/refresh', {
            refresh_token: refreshToken,
          })
          .then((res) => {
            if (res.status === 200) {
              LocalStorageService.setToken(res.data.data);
              hqiSemanticApiInstance.defaults.headers.common['Authorization'] =
                'Bearer ' + LocalStorageService.getAccessToken();
              return hqiSemanticApiInstance(originalRequest);
            } else if (res.status === 203) {
              localStorage.clear();
            }
          });
      } else if (apiError.response.status === 400) {
        return apiError.response;
      } else if (apiError.response.status === 409) {
        return apiError.response;
      }
      return Promise.reject(apiError);
    } catch (error) {
      ErrorLog("API Instance", error);
    }
  }
);

hqiUmApiInstance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hqiUmApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (apiError) {
    try {
      const originalRequest = apiError.config;
      //Try to optimize this @Shweta
      const apiInstance = axios.create({
        baseURL: localStorage.refreshTokenUrl,
      });
      
      if (apiError.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = LocalStorageService.getRefreshToken();
        let url = window.location.hostname == 'localhost' ? 'https://hqi-dev.axtria.com' : window.location.origin;
        return axios
          .post(url+'/umbackend'+'/refresh', {
            refresh_token: refreshToken,
          })
          .then((res) => {
            if (res.status === 200) {
              LocalStorageService.setToken(res.data.data);
              hqiUmApiInstance.defaults.headers.common['Authorization'] =
                'Bearer ' + LocalStorageService.getAccessToken();
              return hqiUmApiInstance(originalRequest);
            } else if (res.status === 203) {
              localStorage.clear();
            }
          });
      // TODO's need to handle the 400 and above the status code in catch block
      } else if (apiError.response.status === 400) {
        return apiError.response;
      } else if (apiError.response.status === 409) {
        return apiError.response;
      }
      return Promise.reject(apiError);
    } catch (error) {
      //Call error message component and pass msg.
      ErrorLog("API Instance", error);
    }
  }
);

export const hqiMiddlewareApiInstance = axios.create({
  baseURL: defaultMiddlewareApi,
});

hqiMiddlewareApiInstance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hqiMiddlewareApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (apiError) {
    try {
      const originalRequest = apiError.config;
      
      if (apiError.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = LocalStorageService.getRefreshToken();
        let url = window.location.hostname == 'localhost' ? 'https://hqi-dev.axtria.com' : window.location.origin;
        return axios
          .post(url+'/umbackend'+'/refresh', {
            refresh_token: refreshToken,
          })
          .then((res) => {
            if (res.status === 200) {
              LocalStorageService.setToken(res.data.data);
              hqiMiddlewareApiInstance.defaults.headers.common['Authorization'] =
                'Bearer ' + LocalStorageService.getAccessToken();
              return hqiMiddlewareApiInstance(originalRequest);
            } else if (res.status === 203) {
              localStorage.clear();
            }
          });
      } else if (apiError.response.status === 400) {
        return apiError.response;
      } else if (apiError.response.status === 409) {
        return apiError.response;
      }
      return Promise.reject(apiError);
    } catch (error) {
      ErrorLog("API Instance", error);
    }
  }
);
